export default {
  APPLICATION_CREATED: 'Application created',
  APPLICATION_LIST_LOADED: 'Application list loaded',
  APPLICATION_CLICKED: 'Application clicked',
  APPLICATION_LIST_END_REACHED: 'Application list end reached'
};
